import { OrderHistory } from './../models/order-history.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

import { Order } from '../models/order.model';
import { BaseService } from './base.service';
import { OrderItemHeader } from '../models/order-item-header.model';
import { OrderDocument } from '../models/order-document.model';
import { OrderDocumentData } from '../models/order-document-data.model';
import { catchError } from 'rxjs/operators';
import { OrderDocumentHistory } from '../models/order-document-history.model';

@Injectable()
export class OrderService {
  private historySource = new Subject();
  historySource$ = this.historySource.asObservable();
  constructor(private httpClient: HttpClient,
    private baseService: BaseService
  ) { }
  autocompleteType(topic: string): Observable<Order[]> {
    const url = `${this.baseService.hostDomain}/api/order/type/ac/${topic}`;
    return this.httpClient.get<Order[]>(url).pipe(
      catchError(err => {
        this.baseService.handleError(err, 'Buscando las órdenes');
        return [];
      })
    );
  }
  getType(id: string): Observable<Order> {
    const url = `${this.baseService.hostDomain}/api/order/type/${id}`;
    return this.httpClient.get<Order>(url).pipe(
      catchError(err => {
        this.baseService.handleError(err, `Obteniendo la orden ${id}`);
        return [];
      })
    );
  }
  itemType(id: string, line: number): Observable<OrderItemHeader> {
    const url = `${this.baseService.hostDomain}/api/order/type/${id}/${line}`;
    return this.httpClient.get<OrderItemHeader>(url).pipe(
      catchError(err => {
        this.baseService.handleError(err, `Obteniendo la orden ${id}, item ${line}`);
        return [];
      })
    );
  }

  autocompleteValidate(topic: string): Observable<Order[]> {
    const url = `${this.baseService.hostDomain}/api/order/validate/ac/${topic}`;
    return this.httpClient.get<Order[]>(url).pipe(
      catchError(err => {
        this.baseService.handleError(err, 'Buscando las órdenes');
        return [];
      })
    );
  }
  getValidate(id: string): Observable<Order> {
    const url = `${this.baseService.hostDomain}/api/order/validate/${id}`;
    return this.httpClient.get<Order>(url).pipe(
      catchError(err => {
        this.baseService.handleError(err, `Obteniendo la orden ${id}`);
        return [];
      })
    );
  }

  autocompleteSearch(topic: string): Observable<Order[]> {
    const url = `${this.baseService.hostDomain}/api/order/search/ac/${topic}`;
    return this.httpClient.get<Order[]>(url).pipe(
      catchError(err => {
        this.baseService.handleError(err, 'Buscando las órdenes');
        return [];
      })
    );
  }
  getSearch(id: string): Observable<Order> {
    const url = `${this.baseService.hostDomain}/api/order/search/${id}`;
    return this.httpClient.get<Order>(url).pipe(
      catchError(err => {
        this.baseService.handleError(err, `Obteniendo la orden ${id}`);
        return [];
      })
    );
  }
  itemSearch(id: string, line: number): Observable<OrderItemHeader> {
    const url = `${this.baseService.hostDomain}/api/order/search/${id}/${line}`;
    return this.httpClient.get<OrderItemHeader>(url).pipe(
      catchError(err => {
        this.baseService.handleError(err, `Obteniendo la orden ${id}, item ${line}`);
        return [];
      })
    );
  }

  refreshHistory() {
    this.historySource.next();
  }

  history(id: string): Observable<OrderHistory[]> {
    const url = `${this.baseService.hostDomain}/api/order/history/${id}`;
    return this.httpClient.get<OrderHistory[]>(url).pipe(
      catchError(err => {
        this.baseService.handleError(err, `Obteniendo la orden ${id}`);
        return [];
      })
    );
  }

  historyDocument(id: string, line: number, idx: number): Observable<OrderDocumentHistory[]> {
    const url = `${this.baseService.hostDomain}/api/order/document/history/${id}-${line}-${idx}`;
    return this.httpClient.get<OrderDocumentHistory[]>(url).pipe(
      catchError(err => {
        this.baseService.handleError(err, `Obteniendo el historial del documento ${id}-${line}-${idx}`);
        return [];
      })
    );
  }

  saveDocument(orderDocument: OrderDocument): Observable<boolean> {
    const url = `${this.baseService.hostDomain}/api/order/document`;
    return this.httpClient.post<boolean>(url, orderDocument).pipe(
      catchError(err => {
        this.baseService.handleError(err, `Guardando el edicto ${orderDocument.orderId}-${orderDocument.line}-${orderDocument.index}`);
        return [];
      })
    );
  }

  cancelSaveDocument(orderDocument: OrderDocument): Observable<boolean> {
    const url = `${this.baseService.hostDomain}/api/order/document/cancel`;
    return this.httpClient.post<boolean>(url, orderDocument).pipe(
      catchError(err => {
        this.baseService.handleError(err, `Corregir digitación ${orderDocument.orderId}-${orderDocument.line}-${orderDocument.index}`);
        return [];
      })
    );
  }

  saveDocumentData(orderDocument: OrderDocument, orderDocumentData: OrderDocumentData): Observable<boolean> {
    const url = `${this.baseService.hostDomain}/api/order/document/data`;
    return this.httpClient.post<boolean>(url, {
      lapse: orderDocument.lapse,
      orderId: orderDocument.orderId,
      line: orderDocument.line,
      index: orderDocument.index,
      key: orderDocumentData.key,
      value: orderDocumentData.value
    }).pipe(
      catchError(err => {
        this.baseService.handleError(err, 'Guardado automático.');
        return [];
      })
    );
  }

  validate(id: string): Observable<boolean> {
    const url = `${this.baseService.hostDomain}/api/order/validate`;
    return this.httpClient.post<boolean>(url, {
      id: id
    }).pipe(
      catchError(err => {
        this.baseService.handleError(err, 'Validando orden.');
        return [];
      })
    );
  }

  invalidate(id: string, comment: string): Observable<boolean> {
    const url = `${this.baseService.hostDomain}/api/order/invalidate`;
    return this.httpClient.post<boolean>(url, {
      id: id,
      comment: comment
    }).pipe(
      catchError(err => {
        this.baseService.handleError(err, 'Invalidando orden.');
        return [];
      })
    );
  }
}
